/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Assessment update request
 * @export
 * @interface AssessmentUpdateRequest
 */
export interface AssessmentUpdateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentUpdateRequest
     */
    controlIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentUpdateRequest
     */
    groupIds?: Array<string>;
}

/**
 * Check if a given object implements the AssessmentUpdateRequest interface.
 */
export function instanceOfAssessmentUpdateRequest(value: object): value is AssessmentUpdateRequest {
    return true;
}

export function AssessmentUpdateRequestFromJSON(json: any): AssessmentUpdateRequest {
    return AssessmentUpdateRequestFromJSONTyped(json, false);
}

export function AssessmentUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssessmentUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'controlIds': json['controlIds'] == null ? undefined : json['controlIds'],
        'groupIds': json['groupIds'] == null ? undefined : json['groupIds'],
    };
}

export function AssessmentUpdateRequestToJSON(json: any): AssessmentUpdateRequest {
    return AssessmentUpdateRequestToJSONTyped(json, false);
}

export function AssessmentUpdateRequestToJSONTyped(value?: AssessmentUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'controlIds': value['controlIds'],
        'groupIds': value['groupIds'],
    };
}

